export const MsgType = {

  WEB_MSG_NONE : 0xA0, // 默认为空
    WEB_MSG_OK: 0xF0, // 成功
    WEB_MSG_FAILED : 0xF1,  // 失败
    WEB_MSG_SET_SYS_PARAM  : 0xA1,  // 设置基站参数
    WEB_MSG_SET_IDLE_MODE  : 0xA2,  // 设置基站为idle模式
    WEB_MSG_SET_WAV_FILE : 0xA3,  // 设置音频文件
    WEB_MSG_SET_EDGE_AXIS  : 0xA4,  // 设置边缘服务器坐标的参数
    WEB_MSG_GET_EDGE_AXIS  : 0xA5,  // 获取边缘服务器坐标的参数
    WEB_MSG_SET_AREA  : 0xA6,  // 设置边缘服务器的区域信息，每个区域对应一组音频频率
    WEB_MSG_GET_AREA  : 0xA7, // 获取边缘服务器的区域信息，每个区域对应一组音频频率
    WEB_MSG_SEND_POS : 0xA8,  // 上传定位结果
    WEB_MSG_GET_SYS_PARAM  : 0xA9,  // 读取基站参数
    WEB_MSG_SET_PLAY_MODE  : 0xAA,  // 让基站复位
    WEB_MSG_SET_LABEL_FREQ : 0xAB,



}

/*
* ///云端发过来的和发送出去的Mqtt消息类型
#pragma pack(1)
typedef struct
{  
    uint16_t    frame_header;       // 帧头
    uint8_t     message_type;       // 消息类型，表示当前是哪个消息
    uint16_t    message_len;        // 消息长度
    uint8_t     *message;           // 消息内容
    uint16_t    frame_tail;         // 帧尾          
}web_message_info_t;
#pragma pack()
*
*
* */
